import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../auth/useAuth';
import { userService } from '../../../services/UserService';
import { tenantQueryKeys } from '../tenantQueryKeys';

type UseTenantUsersQueryOptions = {
  enabled?: boolean;
};

/**
 * Shared tenant directory users query (organisation users).
 * Paginated via UserService.listUsers() (page size 100, loops until exhausted).
 * Used by org management, KDB/chatbot members, platform chat, and crawls.
 */
export function useTenantUsersQuery(options?: UseTenantUsersQueryOptions) {
  const { user } = useAuth();
  const isEnabled = (options?.enabled ?? true) && Boolean(user);

  return useQuery({
    queryKey: tenantQueryKeys.users(),
    enabled: isEnabled,
    queryFn: () => userService.listUsers(),
  });
}
